// @flow
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { showModal, closeModal } from "../redux/actions/Modals";
import { IllegalArgumentException } from "../exceptions";

type ModalHook = (modalId: string) => {
  key: string | null,
  size: string | null,
  visible: boolean,
  show: () => void,
  close: () => void,
};

/**
 * Manage modals
 */
export const useModal: ModalHook = (modalId: string) => {
  if (!modalId) {
    throw new IllegalArgumentException(
      "Missing modalId argument for useModal hook",
    );
  }

  const dispatch = useDispatch();
  const modal = useSelector(({ modals }) =>
    modals.modals.find((m) => m.key === modalId),
  );

  const show = useCallback(() => {
    dispatch(showModal(modalId));
  }, [dispatch, modalId]);

  const close = useCallback(() => {
    dispatch(closeModal(modalId));
  }, [dispatch, modalId]);

  return {
    key: modal ? modal.key : null,
    size: modal ? modal.size : null,
    visible: modal ? modal.visible : false,
    show,
    close,
  };
};
